import { ServicePricing } from '@/components/services/ServicePricing'
import { serviceOffers } from '@/data/pricing'

export const IntegratedHealthPricing = () => (
  <ServicePricing
    title="Your consultation,"
    accent="brought together"
    description="Your health history, scan findings and next steps, considered together with Kandake."
    offers={[serviceOffers.integratedConsult]}
  />
)
